// get ecustomer list for admin workforce
export const RESET_ASSIGN_CUSTOMER_TO_EMPLOYEE = "RESET_ASSIGN_CUSTOMER_TO_EMPLOYEE";
export const ASSIGN_CUSTOMER_TO_EMPLOYEE = "ASSIGN_CUSTOMER_TO_EMPLOYEE";
export const ASSIGN_CUSTOMER_TO_EMPLOYEE_SUCCESS = "ASSIGN_CUSTOMER_TO_EMPLOYEE_success";
export const ASSIGN_CUSTOMER_TO_EMPLOYEE_FAILURE = "ASSIGN_CUSTOMER_TO_EMPLOYEE_failure";
